import { EMAIL_REGEX } from "./constants";
import type { EmailValue } from "./types";

export const formatEmailInputOption = (email: string): EmailValue => ({
  label: email,
  value: email,
  valid: EMAIL_REGEX.test(email),
});

export const pruneDuplicates = (
  existing: EmailValue[],
  newEmailStrings: string[]
): { uniqueEmails: EmailValue[]; duplicates: string[] } => {
  const seen = new Set(existing.map(e => e.value.toLowerCase()));
  const duplicates: string[] = [];
  const added: EmailValue[] = [];

  for (const emailStr of newEmailStrings) {
    const lower = emailStr.toLowerCase();
    if (seen.has(lower)) {
      duplicates.push(emailStr);
    } else {
      seen.add(lower);
      added.push(formatEmailInputOption(emailStr));
    }
  }

  return { uniqueEmails: [...existing, ...added], duplicates };
};

export const filterValidEmails = (emails: EmailValue[]): EmailValue[] =>
  emails.filter(email => email.valid);

export const pluralizeEmail = (count: number): string =>
  count === 1 ? "email" : "emails";

export const formatDuplicateWarning = (duplicates: string[]): string => {
  const count = duplicates.length;

  return `Removed ${count} duplicate ${pluralizeEmail(count)} from the list: ${duplicates.join(", ")}`;
};
